export default "__VITE_ASSET__I4A7r21B__"